/**
 * A row of mutually exclusive tabs.
 *
 * On a phone the row scrolls sideways rather than wrapping, so long labels stay
 * on one line and the control keeps a predictable height. On a wide screen it
 * wraps exactly as the plain button row it replaces did.
 */
export function Segmented<T extends string>({
  options,
  value,
  onChange,
  label,
}: {
  options: { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
  label?: string;
}) {
  return (
    <div
      role="tablist"
      aria-label={label}
      className="mb-4 -mx-1 flex gap-2 overflow-x-auto px-1 pb-1 md:mx-0 md:flex-wrap md:overflow-visible md:px-0 md:pb-0"
    >
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          role="tab"
          aria-selected={value === option.value}
          onClick={() => onChange(option.value)}
          className={`shrink-0 rounded-full border px-4 py-2 text-xs font-bold uppercase tracking-wide transition md:py-1.5 ${
            value === option.value
              ? 'border-brand bg-brand-soft text-brand-deep'
              : 'border-surface-border bg-white text-ink-body hover:border-brand'
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
